import React from 'react';

function AppShowcase() {
  return (
    <section className="showcase reveal">
      <div className="section-header">
        <h2>Ein Blick in die Plattform</h2>
        <p>Intelligente Werkzeuge – designed für maximale Effizienz.</p>
      </div>

      <div className="showcase-grid">

        {/* Leadership Hub */}
        <div className="showcase-card">
          <div className="showcase-card__header">
            <span className="showcase-card__icon">🏢</span>
            <div>
              <div className="showcase-card__title">Leadership Hub</div>
              <div className="showcase-card__sub">Delegierte Aufgaben · Verantwortlichkeiten · Status</div>
            </div>
          </div>
          <div className="showcase-card__screen">
            <div className="mock-section-label">Offene Delegationen</div>
            <div className="mock-task mock-task--high">🔴 Max → Monatsreport bis Fr. · 2 Tage überfällig</div>
            <div className="mock-task mock-task--mid">🟠 Martina → Kundenpräsentation · Wiedervorlage Mo.</div>
            <div className="mock-task mock-task--low">🟢 Marvin → SLA-Doku → in Bearbeitung</div>
            <div className="mock-section-label" style={{ marginTop: '12px' }}>Offene Entscheidungen</div>
            <div className="mock-item">⚡ Budgetfreigabe Q3 – Frist 05.06.</div>
            <div className="mock-item">⚡ Teamstruktur nach Umzug – offen</div>
          </div>
        </div>

        {/* Meeting-Analyse */}
        <div className="showcase-card">
          <div className="showcase-card__header">
            <span className="showcase-card__icon">📝</span>
            <div>
              <div className="showcase-card__title">Meeting-Analyse</div>
              <div className="showcase-card__sub">Transkript → Protokoll + Aufgaben</div>
            </div>
          </div>
          <div className="showcase-card__screen">
            <div className="mock-section-label">Entscheidungen</div>
            <div className="mock-item">✓ Release-Datum auf Q3 verschoben</div>
            <div className="mock-item">✓ Budget für Marketing freigegeben</div>
            <div className="mock-section-label" style={{ marginTop: '12px' }}>Aufgaben</div>
            <div className="mock-task mock-task--high">Anna → Roadmap bis Mo. aktualisieren</div>
            <div className="mock-task mock-task--mid">Tim → Budget-Plan einreichen</div>
            <div className="mock-item" style={{ marginTop: '8px', color: 'rgba(255,255,255,0.4)', fontSize: '11px' }}>Follow-up: Nächstes Meeting – 12.06.</div>
          </div>
        </div>

        {/* Wissensarchiv */}
        <div className="showcase-card">
          <div className="showcase-card__header">
            <span className="showcase-card__icon">🧠</span>
            <div>
              <div className="showcase-card__title">Wissensarchiv</div>
              <div className="showcase-card__sub">Frage dein Archiv – KI antwortet mit Quellen</div>
            </div>
          </div>
          <div className="showcase-card__screen showcase-card__screen--chat">
            <div className="mock-bubble mock-bubble--user">Was haben wir zur Rufbereitschaft entschieden?</div>
            <div className="mock-bubble mock-bubble--ai">Im Meeting vom 14.03. wurde beschlossen: Rufbereitschaft gilt für P1 und P2, Reaktionszeit 30 Min. Verantwortlich: Thomas S. <span style={{ opacity: 0.6, fontSize: '10px' }}>[Quelle: Meeting-Protokoll 14.03.]</span></div>
          </div>
        </div>

        {/* Operations Coach */}
        <div className="showcase-card">
          <div className="showcase-card__header">
            <span className="showcase-card__icon">💼</span>
            <div>
              <div className="showcase-card__title">Leadership Coach</div>
              <div className="showcase-card__sub">Führungssituationen meistern</div>
            </div>
          </div>
          <div className="showcase-card__screen showcase-card__screen--chat">
            <div className="mock-bubble mock-bubble--user">Mitarbeiter kommt regelmäßig zu spät. Wie gehe ich das Gespräch an?</div>
            <div className="mock-bubble mock-bubble--ai">Strukturierter Gesprächsleitfaden: 1. Situation sachlich beschreiben, 2. Auswirkung benennen, 3. Erwartung klar formulieren, 4. Lösungsvereinbarung treffen. Risiken und Fragetechniken anbei.</div>
          </div>
        </div>

      </div>
    </section>
  );
}

export default AppShowcase;
